import React, { useState, useEffect, useRef, useCallback } from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import Swiper from "react-id-swiper"

import Heading from "./Heading"
import Image from "./Image"

import styles from "./cartupsell.module.scss"
// import swiperStyles from "./swiper.module.scss"

import cart from "../helpers/cart"


const CartUpsell = ({ setCartItems }) => {

  const data = useStaticQuery(graphql`
    query UpsellQuery {
      productCollection(handle: { eq: "cart-add-ons" }) {
        id
        handle
        title
        styles {
          ...UpsellStyleFragment
        }
      }
    }
  `)

  const products = data.productCollection.styles

  const cartItems = cart.getCart()

  // Filter out any upsell products that are already in cart
  const productsFiltered = products.filter(p => {
    return !cartItems.find(item => item.variantId === p.skus[0].variants[0].variant_id)
  })

  const [upsellSwiper, getUpsellSwiper] = useState(null)

  const prevBtnEl = useRef(null)
  const nextBtnEl = useRef(null)

  const params = {
    containerClass: `${styles.swiperContainer} swiper-container`,
    WrapperEl: "ul",
    // slideClass: `${styles.swiperSlide} swiper-slide`,
    getSwiper: getUpsellSwiper,
    // threshold: 10,
    watchOverflow: true,
    // preloadImage: true,
    // updateOnImagesReady: true,
    spaceBetween: 20,
    slidesPerView: 1.2,
    centeredSlides: true,
    breakpoints: {
      // when window width is >= 768px
      768: {
        spaceBetween: 40,
        slidesPerView: 1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
    },
    // pagination: {
    //   el: `.${styles.swiperPagination} .swiper-pagination`,
    //   bulletElement: "li",
    //   bulletClass: `${styles.swiperPaginationBullet} swiper-pagination-bullet`,
    //   bulletActiveClass: `${styles.swiperPaginationBulletActive} swiper-pagination-bullet-active`,
    //   clickable: true,
    // },
    // navigation: {
    //   nextEl: `.${styles.swiperButtonNext} .swiper-button-next`,
    //   prevEl: `.${styles.swiperButtonPrev} .swiper-button-prev`,
    // },
    // rebuildOnUpdate: true,
  }

  const updateNavigation = useCallback(
    () => {
      prevBtnEl.current.style.display = (upsellSwiper.isBeginning) ? "none" : "block"
      nextBtnEl.current.style.display = (upsellSwiper.isEnd) ? "none" : "block"
    }, [upsellSwiper])

  useEffect(() => {
    if (upsellSwiper !== null) {
      upsellSwiper.update()
      if (prevBtnEl.current !== null && nextBtnEl.current !== null)
        updateNavigation()
    }
  }, [productsFiltered, upsellSwiper, updateNavigation])

  return(
    <>
      {productsFiltered.length > 0 &&
        <div className={styles.upsell}>
          <Heading
            tag="h2"
            level="2"
            className={styles.heading}
          >
            Works Well With
          </Heading>
          <Swiper {...params}>
            {productsFiltered.map((product, i) => (
              <UpsellSlide
                key={i}
                product={product}
                setCartItems={setCartItems}
              />
            ))}
          </Swiper>
          {productsFiltered.length > 1 &&
            <>
              <button
                className={`${styles.swiperButtonPrev} swiper-navigation-prev`}
                onClick={() => {
                  upsellSwiper.slidePrev()
                  updateNavigation()
                }}
                ref={prevBtnEl}
              />
              <button
                className={`${styles.swiperButtonNext} swiper-navigation-next`}
                onClick={() => {
                  upsellSwiper.slideNext()
                  updateNavigation()
                }}
                ref={nextBtnEl}
              />
            </>
          }
        </div>
      }
    </>
  )
}

export default CartUpsell

const UpsellSlide = ({ product, setCartItems }) => {

  const handleAtcClick = () => {
    const item = {
      variantId: product.skus[0].variants[0].variant_id,
      quantity: 1,
      image: product.skus[0].images.pdp[0],
      title: product.title,
      price: product.skus[0].variants[0].price,
      url: product.url,
      color: product.skus[0].color,
      size: product.skus[0].variants[0].size,
    }
    cart.addItem(item)
    setCartItems(cart.getCart())
    window.scrollTo(0,0)
  }

  return(
    <li
      className={`${styles.swiperSlide} swiper-slide`}
    >
      <Link
        to={product.url}
        className={styles.imageLink}
      >
        <Image
          image={product.skus[0].images.pdp[0]}
          alt={product.title}
          className={styles.image}
          options={{
            origin: "shopify",
            width: "266",
          }}
        />
      </Link>
      <div className={styles.content}>
        <Heading
          tag="h4"
          level="4"
          className={styles.title}
        >
          {product.title}
        </Heading>
        <h5 className={styles.subtitle}>
          {product.upsell_subtitle}
        </h5>
        <p className={styles.description}>
          {product.upsell_description}
        </p>
      </div>
      <button
        className={styles.atcBtn}
        onClick={handleAtcClick}
      >
        ${product.skus[0].variants[0].price} - Add to Cart
      </button>
    </li>
  )
}
